import { IonChip, IonSpinner, IonToolbar } from '@ionic/react';
import React, { useContext, useEffect, useRef, useState } from 'react';
import { UserContext } from '../../contexts';
import { Customer } from '../../models';
import { customerResource } from '../../resource';
import './balanceInformation.scss';

interface Props {
  status: string;
}

export const BalanceCustomerInformation: React.FC<Props> = ({ status }) => {
  const { user, isCustomer } = useContext(UserContext);
  const customerUser = user as Customer;

  const [remainingMinutes, setMinutesToUse] = useState<number>(0);

  const [isLoading, setLoading] = useState<boolean>(false);

  // Track if component is mounted to prevent state updates on unmounted component
  const isMountedRef = useRef(true);

  // Define class for remainingFreeMinutes Chip
  const minutesChipClass =
    remainingMinutes > 1
      ? 'success'
      : remainingMinutes > 0
        ? 'warning'
        : 'danger';

  // Refresh Customer credits information every 10 seconds.
  useEffect(() => {
    if (customerUser) {
      refreshCreditsInformation();

      const timer = window.setInterval(refreshCreditsInformation, 10000);
      return () => {
        clearInterval(timer);
        isMountedRef.current = false;
      };
    }
  }, [customerUser]);

  const refreshCreditsInformation = async () => {
    if (!customerUser || !customerUser['@id']) return;

    if (isMountedRef.current) {
      setLoading(true);
    }

    const refreshedCustomer = await customerResource.find(customerUser['@id']);

    // Only update state if component is still mounted
    if (isMountedRef.current) {
      if (refreshedCustomer) {
        setMinutesToUse(refreshedCustomer.minutesToUse);
      }
      setLoading(false);
    }
  };

  // Only render for customers who have minutes available
  if (!isCustomer) {
    return null;
  }

  const displayRemainingMinutes =
    remainingMinutes > 0 ? remainingMinutes + 1 : 0;

  return (
    <IonToolbar className="text-center">
      {isLoading ? (
        <IonChip color={minutesChipClass} className="chat-timer">
          <IonSpinner name={'lines-small'} color={minutesChipClass} />
          {` min left`}
        </IonChip>
      ) : (
        <IonChip color={minutesChipClass} className="chat-timer">
          {`${displayRemainingMinutes} min left`}
        </IonChip>
      )}
    </IonToolbar>
  );
};
